exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".pi-footer[data-v-76cb90d8]{display:flex;flex-wrap:wrap;gap:4px 14px;margin:16px 0 0;padding-top:10px;border-top:1px solid #eef0f2;font-size:11px;color:#6b7280}.pi-footer .pi-link[data-v-76cb90d8]{font-size:11px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-76cb90d8","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=1!./src/vue/pages/components/pi/piPageFooter.vue
// module id = 1667
// module chunks = 0